var _defs, _polygon, _g, _g2, _g3, _polygon2, _polygon3, _polygon4, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8b7f6e;\n      }\n\n      .cls-2 {\n        fill: #a09f9f;\n      }\n\n      .cls-3 {\n        fill: #ececec;\n      }\n\n      .cls-4 {\n        fill: #65635f;\n      }\n\n      .cls-5 {\n        fill: #b1b1b0;\n      }\n\n      .cls-6 {\n        fill: #493522;\n      }\n\n      .cls-7 {\n        fill: #76614a;\n      }\n\n      .cls-8 {\n        fill: #3f3e3e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "485.27 770.46 60.13 637.61 600.97 542.27 1019.87 599.97 485.27 770.46"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.69 627.22 129.69 634.3 587.35 547.16 587.35 540.08 129.69 627.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.69 627.22 587.35 540.08 581.99 538.28 129.69 622.94 129.69 627.22"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "496.49 557.53 501.85 556.86 501.85 386.45 496.49 386.45 496.49 557.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "491.13 555.29 496.49 557.53 496.49 386.45 491.13 387.96 491.13 555.29"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "600.11 343.88 501.85 386.45 496.49 386.45 594.75 343.88 600.11 343.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "496.7 429.03 496.49 420.97 520.24 376.16 525.66 373.9 496.7 429.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "496.7 429.03 501.85 429.03 530.81 373.9 525.66 373.9 496.7 429.03"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "491.13 389.02 491.13 384.99 594.75 338.88 594.75 343.88 491.13 389.02"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "944.61 393.42 963.19 422.96 965.07 412.48 953.07 393.42 944.61 393.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "953.07 393.42 965.07 412.48 972.08 414.21 958.99 393.42 953.07 393.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "967.53 393.42 967.53 594.56 972.89 593.06 972.89 393.42 967.53 393.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "962.18 393.42 962.18 592.33 967.53 594.56 967.53 393.42 962.18 393.42"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "123.89 397.23 269.64 328.21 528.61 322.64 402.62 392.15 134.6 408.71 123.89 397.23"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "117.35 415 116.77 406.45 441.79 390.54 436.43 396.27 117.35 415"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "117.35 415 506.24 394.11 503.34 390.54 123.89 411.96 117.35 415"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "519.3 372.36 173.92 381.38 174.06 378.29 519.45 368.68 519.3 372.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "519.17 375.44 173.79 384.46 173.92 381.38 519.32 371.77 519.17 375.44"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "563.71 348.57 218.34 357.59 218.47 354.5 563.87 344.89 563.71 348.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "563.58 351.65 218.21 360.68 218.34 357.59 563.74 347.98 563.58 351.65"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "586.93 547.16 592.29 545.65 592.29 319.86 586.93 319.86 586.93 547.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "581.58 544.92 586.93 547.16 586.93 319.86 581.58 321.36 581.58 544.92"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "967.53 587.52 508.7 730.92 508.7 738 967.53 594.6 967.53 587.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "967.53 587.52 508.7 730.92 506.02 726.76 962.18 585.73 967.53 587.52"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "506.24 497.13 504.36 507.61 458.68 434.99 467.14 434.99 506.24 497.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "506.24 497.13 513.25 498.86 467.56 426.24 467.14 434.99 506.24 497.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "508.7 738 514.06 736.49 514.06 446.43 508.7 446.43 508.7 738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "503.34 735.76 508.7 738 508.7 446.43 503.34 447.94 503.34 735.76"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "600.71 494.23 598.84 504.71 553.15 432.09 561.62 432.09 600.71 494.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "600.71 494.23 607.72 495.96 562.04 423.34 561.62 432.09 600.71 494.23"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "603.18 701.16 608.53 699.65 608.53 443.54 603.18 443.54 603.18 701.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "597.82 698.92 603.18 701.16 603.18 443.54 597.82 445.04 597.82 698.92"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "695.19 465.3 693.31 475.77 647.63 403.15 656.1 403.15 695.19 465.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "695.19 465.3 702.2 467.03 656.51 394.4 656.1 403.15 695.19 465.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "697.65 672.23 703.01 670.72 703.01 414.6 697.65 414.6 697.65 672.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "692.3 669.99 697.65 672.23 697.65 414.6 692.3 416.11 692.3 669.99"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "789.66 435.14 787.79 445.62 742.11 373 750.57 373 789.66 435.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "789.66 435.14 796.67 436.87 750.99 364.25 750.57 373 789.66 435.14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "792.13 642.08 797.48 640.57 797.48 384.45 792.13 384.45 792.13 642.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "786.77 639.84 792.13 642.08 792.13 384.45 786.77 385.96 786.77 639.84"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "864.27 400.56 880.17 425.83 882.04 415.35 872.74 400.56 864.27 400.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "872.74 400.56 882.04 415.35 889.05 417.08 878.66 400.56 872.74 400.56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "884.5 400.56 884.5 613.67 889.86 612.16 889.86 400.56 884.5 400.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "879.15 400.56 879.15 611.43 884.5 613.67 884.5 400.56 879.15 400.56"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "222.9 609.31 228.26 608.65 228.26 403.09 222.9 403.09 222.9 609.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "217.55 607.08 222.9 609.31 222.9 403.09 217.55 404.6 217.55 607.08"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "326.52 360.52 228.26 403.09 222.9 403.09 321.16 360.52 326.52 360.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "223.11 445.67 222.9 437.61 246.65 392.8 252.07 390.54 223.11 445.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "223.11 445.67 228.26 445.67 257.22 390.54 252.07 390.54 223.11 445.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "217.55 405.66 217.55 401.64 321.16 355.52 321.16 360.52 217.55 405.66"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "322.38 590.48 327.74 589.81 327.74 397.96 322.38 397.96 322.38 590.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "317.02 588.24 322.38 590.48 322.38 397.96 317.02 399.46 317.02 588.24"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "425.99 355.39 327.74 397.96 322.38 397.96 420.64 355.39 425.99 355.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "322.59 440.53 322.38 432.48 346.13 387.67 351.55 385.41 322.59 440.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "322.59 440.53 327.74 440.53 356.7 385.41 351.55 385.41 322.59 440.53"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "317.02 400.53 317.02 396.5 420.64 350.39 420.64 355.39 317.02 400.53"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "402.62 576.07 407.98 575.41 407.98 388.12 402.62 388.12 402.62 576.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "397.27 573.83 402.62 576.07 402.62 388.12 397.27 389.63 397.27 573.83"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "506.24 345.55 407.98 388.12 402.62 388.12 500.88 345.55 506.24 345.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "402.83 430.7 402.62 422.64 426.37 377.83 431.79 375.57 402.83 430.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "402.83 430.7 407.98 430.7 436.94 375.57 431.79 375.57 402.83 430.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "397.27 390.69 397.27 386.66 500.88 340.55 500.88 345.55 397.27 390.69"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.24 634.31 134.6 633.64 134.6 401.18 129.24 401.18 129.24 634.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "123.89 632.07 129.24 634.31 129.24 401.18 123.89 402.69 123.89 632.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "232.86 358.61 134.6 401.18 129.24 401.18 227.5 358.61 232.86 358.61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.45 443.75 129.24 435.7 152.99 390.89 158.41 388.63 129.45 443.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.45 443.75 134.6 443.75 163.56 388.63 158.41 388.63 129.45 443.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "123.89 403.75 123.89 399.72 227.5 353.61 227.5 358.61 123.89 403.75"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "269.64 325.17 102.89 402.99 103.44 404.18 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "269.64 325.17 505.13 446.43 505.13 447.63 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "986.94 392.15 505.13 446.43 505.13 447.63 986.94 393.34 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "986.94 392.15 505.13 446.43 269.64 325.17 774.8 309.54 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "269.64 338.98 109.09 415 109.09 404.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "269.64 338.98 505.13 460.01 505.13 449.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "103.44 404.18 109.09 404.24 269.64 328.21 269.64 326.36 103.44 404.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "109.09 415 269.64 338.98 274.76 341.61 117.35 415 109.09 415"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "269.64 328.21 269.64 326.36 505.13 447.63 505.13 449.24 269.64 328.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "980.6 401.03 505.13 460.01 505.13 449.24 980.6 395.91 980.6 401.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "980.6 395.91 980.6 394.06 505.13 447.63 505.13 449.24 980.6 395.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "584.7 315.42 805.49 412.59 817 411.3 596.11 315.07 584.7 315.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "428.68 320.25 657.15 429.31 669.17 427.95 440.48 319.88 428.68 320.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "331.57 323.26 563.79 439.83 576.12 438.44 343.59 322.88 331.57 323.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "350.97 322.65 582.5 437.72 594.77 436.34 362.95 322.28 350.97 322.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "643.43 313.6 860.77 406.36 872.08 405.09 654.68 313.26 643.43 313.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "545.62 316.63 768.53 416.76 780.17 415.45 557.13 316.27 545.62 316.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "604.26 314.82 823.94 410.51 835.38 409.22 615.62 314.46 604.26 314.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "623.84 314.21 842.37 408.44 853.74 407.16 635.15 313.86 623.84 314.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "312.18 323.86 545.07 441.94 557.45 440.54 324.25 323.48 312.18 323.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "467.61 319.04 694.36 425.11 706.26 423.77 479.32 318.68 467.61 319.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "292.8 324.45 526.32 444.05 538.76 442.65 304.91 324.08 292.8 324.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "409.24 320.85 638.52 431.41 650.6 430.04 421.08 320.48 409.24 320.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "448.14 319.65 675.76 427.21 687.72 425.86 459.89 319.28 448.14 319.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "487.1 318.44 712.93 423.02 724.77 421.69 498.75 318.08 487.1 318.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "526.1 317.23 750.02 418.84 761.72 417.52 537.66 316.88 526.1 317.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "370.38 322.05 601.19 435.61 613.4 434.24 382.32 321.68 370.38 322.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "506.59 317.84 731.48 420.93 743.26 419.6 518.2 317.48 506.59 317.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "389.8 321.45 619.86 433.51 632.01 432.14 401.69 321.08 389.8 321.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "565.15 316.03 787.02 414.67 798.6 413.37 576.61 315.67 565.15 316.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "721.93 311.17 934.17 398.09 945.2 396.85 732.97 310.83 721.93 311.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "269.64 325.17 505.13 446.43 520.05 444.75 285.59 324.68 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "702.28 311.78 915.85 400.16 926.95 398.91 713.38 311.44 702.28 311.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "682.65 312.39 897.52 402.22 908.69 400.97 693.8 312.04 682.65 312.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "986.94 392.15 774.8 309.54 761.27 309.96 970.73 393.98 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "663.03 313 879.16 404.29 890.4 403.03 674.23 312.65 663.03 313"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "752.58 310.23 741.59 310.57 952.46 396.03 963.42 394.8 752.58 310.23"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "210.12 367.16 225.27 359.99 307.75 358.61 321.8 365.78 210.12 367.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.12,367.16l111.68-1.38,1.33.69s-105.02,1.91-105.59,1.82-7.43-1.13-7.43-1.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarport);
export default __webpack_public_path__ + "static/media/carport.438667fb489291391c0084b8ec792984.svg";
export { ForwardRef as ReactComponent };